'use strict';

import React from 'react';
import CommentStore from 'stores/CommentStore';
import CommentActions from 'actions/CommentActions';
import Header from './HeaderComponent';
import {Link} from 'react-router';

import 'styles/Comments.scss';

class CommentsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      media_id: this.props.params.id,
      comments: CommentStore.getState().comments
    };
    this.onCommentsChange = this.onCommentsChange.bind(this);

  }
  componentDidMount() {
    let media_id = this.props.params.id;
    CommentActions.fetchComments(media_id);
    CommentStore.listen(this.onCommentsChange);

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    CommentStore.unlisten(this.onCommentsChange);
  }
  onCommentsChange(comments) {
    this.setState({comments: comments.comments});
  }
  render() {
    return (
      <div className="comments-component">
        <Header title="评论" />
        <div className="row">
          {this.state.comments.length === 0 ? <p className="text-gray text-center mt-50 fz-16">这里空空如也～～</p> : ''}
          { this.state.comments.map((comment)=>{
            return (
              <div className="columns" key={comment._id}>
                <div className="comment bg-white">
                  <div className="comment-meta clearfix">
                    <Link to={`/user/comment.author._id`}>
                      <img className="comment-avatar float-left contain" width="30" height="30" src={comment.author.avatar} />
                    </Link>
                    <h4 className="float-left">
                      <Link to={`/user/comment.author._id`}>
                        <span className="text-black">{comment.author.name}</span>
                      </Link>
                    </h4>
                    <span className="fz-12 text-gray float-right">{new Date(comment.create_date).toLocaleDateString()} {new Date(comment.create_date).toLocaleTimeString()}</span>
                  </div>
                  <div className="comment-content">{comment.content}</div>
                </div>
              </div>
            );
          })
          }
        </div>
      </div>
    );
  }
}

CommentsComponent.displayName = 'CommentsComponent';
export default CommentsComponent;



// WEBPACK FOOTER //
// ./src/components/CommentsComponent.js